import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion as BootstrapAccordion, AccordionContext as BootstrapAccContext } from 'react-bootstrap';
export const Accordion = props => (_jsx(BootstrapAccordion, Object.assign({ activeKey: props.activeKey, defaultActiveKey: props.defaultActiveKey, className: props.className, bsPrefix: props.bsPrefix, onSelect: props.onSelect }, { children: props.children })));
export const AccordionContent = BootstrapAccContext;
